export default "__VITE_ASSET__BSYoLeSe__"